import { Injectable } from '@angular/core';
import { Store } from './store';
import { OeAppPersonService } from './oe-app-person.service';

interface ChatBotState {
  showFab: boolean;
  showModal: boolean;
  showWelcomeMessage: boolean;
  showBanner: boolean;
  showHeaderButton: boolean;
  showLcFeedbackModal: boolean;
  showMiniLessonModal: boolean;
}

export const CHAT_BOT_BANNER_HIDDEN_KEY = 'chat-bot-banner-hidden';

@Injectable({ providedIn: 'root' })
export class ChatBotStateService extends Store<ChatBotState> {
  private static initializeState(oeAppPersonService: OeAppPersonService): ChatBotState {
    const { copilotEnabled, hasSeenCopilotOnboarding } = oeAppPersonService;
    const showBanner = copilotEnabled && localStorage.getItem(CHAT_BOT_BANNER_HIDDEN_KEY) !== 'true';
    return {
      showFab: copilotEnabled,
      showModal: false,
      showWelcomeMessage: !hasSeenCopilotOnboarding,
      showBanner,
      showHeaderButton: copilotEnabled && !showBanner,
      showLcFeedbackModal: false,
      showMiniLessonModal: false
    };
  }

  constructor(readonly oeAppPersonService: OeAppPersonService) {
    super(ChatBotStateService.initializeState(oeAppPersonService));
  }

  public openChatBotModal() {
    this.setState({ ...this.state, showModal: true, showFab: false });
  }

  public closeChatBotModal() {
    this.setState({ ...this.state, showModal: false, showFab: true });
  }

  public openChatBotLcFeedbackModal() {
    this.setState({ ...this.state, showLcFeedbackModal: true, showModal: false, showFab: false });
  }

  public closeChatBotLcFeedbackModal() {
    this.setState({ ...this.state, showLcFeedbackModal: false, showFab: true });
  }

  public openChatBotMiniLessonModal() {
    this.setState({ ...this.state, showMiniLessonModal: true });
  }

  public closeChatBotMiniLessonModal() {
    this.setState({ ...this.state, showMiniLessonModal: false });
  }

  public showWelcomeMessage() {
    this.setState({ ...this.state, showWelcomeMessage: true });
  }

  public hideShowWelcomeMessage() {
    this.setState({ ...this.state, showWelcomeMessage: false });
  }

  public showFab() {
    this.setState({ ...this.state, showFab: true });
  }

  public hideFab() {
    this.setState({ ...this.state, showFab: false });
  }

  public showBanner() {
    this.setState({ ...this.state, showBanner: true });
  }

  public hideBanner() {
    this.setState({ ...this.state, showBanner: false });
    localStorage.setItem(CHAT_BOT_BANNER_HIDDEN_KEY, 'true');
  }

  public showHeaderButton() {
    this.setState({ ...this.state, showHeaderButton: true });
  }

  public hideHeaderButton() {
    this.setState({ ...this.state, showHeaderButton: false });
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/chat-bot-state.service.ts